import { Component, OnInit, Input, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { BaseComponent } from '~Interfaces/basecomponent';
import { AuthentificationService } from '../../services/authentification.service';
/**
 * Composant d'usurpation
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-usurpation',
  templateUrl: './usurpation.component.html',
  styleUrls: ['./usurpation.component.scss']
})
export class UsurpationComponent extends BaseComponent implements OnInit {
    valeurUsurpation: string = '';
    @Input() utilisateurUsurpe: string = '';
    @Input() utilisateurSuperviseur: string = '';
    @Input() estUsurpe: boolean = false;
    @Input() possedeDroitUsurpation: boolean = false;

    @Input() afficherSuperviseur: boolean = true;
    @Input() afficherTerminer: boolean = true;

    /**
     * Constructeur
     * @param authentificationService
     * @param router
     */
    constructor(
        @Inject(AuthentificationService) private authentificationService: AuthentificationService,
        private router: Router)
    {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Commencer l'usurpation
     */
    public commencerUsurpation() {
        if (!this.possedeDroitUsurpation || this.estUsurpe || !this.valeurUsurpation) return;

        var login = null;
        var code = null;

        // Login (email)
        if (this.valeurUsurpation && this.valeurUsurpation.indexOf('@') >= 0) {
            login = this.valeurUsurpation;
        }
        // Ou code fournisseur ?
        else {
            code = this.valeurUsurpation;
        }

        // Usurpation
        this.authentificationService.commencerUsurpation(login, code).subscribe((retour) => {
            if (retour && retour.Result === true) {
                this.utilisateurUsurpe = this.valeurUsurpation;
                this.estUsurpe = true;
                window.location.href = '/accueil';
            }
        });
    }

    /**
     * Terminer l'usurpation
     */
    public terminerUsurpation() {
        if (!this.estUsurpe) return;
        this.authentificationService.terminerUsurpation().subscribe((retour) => {
            if (retour && retour.Result === true) {
                this.utilisateurUsurpe = '';
                this.estUsurpe = false;
                window.location.href = '/accueil';
            }
        });
    }
}
